import React, { useState } from 'react';
import { FaEnvelope, FaBan, FaCheck, FaFileAlt } from 'react-icons/fa'; // Import the report icon
import LocalAuthorityTag from './LocalAuthorityTag';
import GenerateReportModal from './GenerateReportModal'; // Import the GenerateReportModal component

const LocalAuthorityItem = ({ name, status }) => {
    const [activateClicked, setActivateClicked] = useState(false);
    const [deactivateClicked, setDeactivateClicked] = useState(false);
    const [isReportModalOpen, setIsReportModalOpen] = useState(false); // State for the report modal

    const itemStyle = {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '15px',
        padding: '20px',
        border: '1px solid rgba(0, 0, 0, .125)',
        borderRadius: '5px',
        backgroundColor: '#fff',
        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
        position: 'relative',
    };

    const contentWrapperStyle = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
    };

    const contentStyle = {
        display: 'flex',
        flexDirection: 'column',
    };

    const actionsStyle = {
        display: 'flex',
        justifyContent: 'flex-end',
        minWidth: '250px',
    };

    const confirmStyle = {
        width: '100%',
        marginTop: '10px',
        padding: '15px',
        borderRadius: '5px',
        backgroundColor: '#f9f9f9',
        border: '2px solid',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
    };

    const activateConfirmStyle = {
        ...confirmStyle,
        borderColor: 'green',
    };

    const deactivateConfirmStyle = {
        ...confirmStyle,
        borderColor: 'red',
    };

    const invertButtonStyle = (color) => ({
        border: `2px solid ${color}`,
        color: `${color}`,
        backgroundColor: 'white',
    });

    const handleActivateClick = () => {
        setActivateClicked(!activateClicked);
        setDeactivateClicked(false);
    };

    const handleDeactivateClick = () => {
        setDeactivateClicked(!deactivateClicked);
        setActivateClicked(false);
    };

    const handleReportClick = () => {
        setIsReportModalOpen(true); // Open the report modal
    };

    const closeReportModal = () => {
        setIsReportModalOpen(false); // Close the report modal
    };

    const textStyle = {
        fontSize: '16px',
        fontWeight: 'bold',
        marginBottom: '10px',
    };

    return (
        <li style={itemStyle}>
            <div style={contentWrapperStyle}>
                <div style={contentStyle}>
                    <h5>{name}</h5>
                    <LocalAuthorityTag status={status} />
                </div>

                <div style={actionsStyle}>
                    {status === 'inactive' ? (
                        <button
                            style={activateClicked ? invertButtonStyle('green') : {}}
                            className="btn btn-success"
                            onClick={handleActivateClick}
                        >
                            <FaCheck /> Activate
                        </button>
                    ) : (
                        <button
                            style={deactivateClicked ? invertButtonStyle('red') : {}}
                            className="btn btn-danger"
                            onClick={handleDeactivateClick}
                        >
                            <FaBan /> Deactivate
                        </button>
                    )}
                    <button className="btn btn-primary" style={{ marginLeft: '10px' }}>
                        <FaEnvelope /> Message
                    </button>
                    <button className="btn btn-secondary" style={{ marginLeft: '10px' }} onClick={handleReportClick}>
                        <FaFileAlt />
                    </button>
                </div>
            </div>

            {activateClicked && (
                <div style={activateConfirmStyle}>
                    <p style={textStyle}>Are you sure you want to activate {name}?</p>
                    <div>
                        <button className="btn btn-success" style={{ marginRight: '10px' }}>Yes</button>
                        <button className="btn btn-secondary" onClick={handleActivateClick}>No</button>
                    </div>
                </div>
            )}
            {deactivateClicked && (
                <div style={deactivateConfirmStyle}>
                    <p style={textStyle}>Are you sure you want to deactivate {name}?</p>
                    <div>
                        <button className="btn btn-danger" style={{ marginRight: '10px' }}>Yes</button>
                        <button className="btn btn-secondary" onClick={handleDeactivateClick}>No</button>
                    </div>
                </div>
            )}

            {/* Report Modal */}
            {isReportModalOpen && <GenerateReportModal onClose={closeReportModal} />}
        </li>
    );
};

export default LocalAuthorityItem;
